module.exports = __webpack_public_path__ + "static/media/Gepackt.cdeeda5a.svg";